import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import creator from 'utils/action-creator';
import axios from 'utils/axios';

import { actions as profileActions } from 'sagas/app/workers/workersProfileSaga';

/**
 * Constants
 */
const REQUEST = '@app/workers/workersprofile/accountSettings/REQUEST';
const SUCCESS = '@app/workers/workersprofile/accountSettings/SUCCESS';
const FAILURE = '@app/workers/workersprofile/accountSettings/FAILURE';
const RESET = '@app/workers/workersprofile/accountSettings/RESET';

/**
 * Initial state
 */
const initState = {
    loading: false,
    errorStatus: '',
    success: null
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */

// Reducer
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.errorStatus = '';
                draft.success = null;
                break;
            case FAILURE:
                draft.loading = false;
                draft.errorStatus = payload;
                break;
            case SUCCESS:
                draft.loading = false;
                draft.success = true;
                break;
            case RESET:
                draft.loading = false;
                draft.errorStatus = '';
                draft.success = null;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    reset: () => creator(RESET)
};

/**
 * Saga functions
 */
export const sagas = {
    *request({ payload }) {
        try {
            const { user_id, worker_id } = payload;
            const response = yield axios.put(`/workers/user/${user_id}`, payload);
            yield put(actions.success(response.data));
            yield put(profileActions.request(worker_id));
        } catch (e) {
            yield put(actions.failure('Submit failed, please contact support!'));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
